module.exports = __webpack_public_path__ + "static/media/flexible.42e5620b.svg";